export class LocalStorageDataCache {
    constructor() {
    }

    get(key, version) {
        let item = localStorage.getItem(key);
        if (item) {
            item = JSON.parse(item);
        }
        else
        {
            return null;
        }

        if (item && (item.version === undefined || (item.version && item.version !== version))) {
            console.log("Cache version mismatch, ignoring cached data for: " + key);
            return null;
        }

        let timeNow = Date.now();
        
        if (item && item.expiry && Date.parse(item.expiry) < timeNow) {
            localStorage.removeItem(key);
            return null;
        }
        if (item && item.value) {
            return JSON.parse(item.value);
        }
        return null;
    }

    set(key, value, expiryTimestamp, version) {
        const item = {
            value: value,
            expiry: expiryTimestamp ? expiryTimestamp : null,
            version: version ? version : null
        };
        localStorage.setItem(key, JSON.stringify(item));
    }
}

export const gDataCache = new LocalStorageDataCache();
